import { Component, OnInit } from '@angular/core';
import { DianService } from '@app/services/dian.service';

declare var bootstrap: any;

@Component({
  selector: 'app-resolucion',
  templateUrl: './resolucion.component.html',
  styleUrls: ['./resolucion.component.css']
})
export class ResolucionComponent implements OnInit {
  dataResolution = [];
  arrayResolution = [];
  

  constructor(private dianService: DianService) { }

  ngOnInit() {
    this.getResolution();
  }

  openDialog(items = []): void {
    const modalElement = document.getElementById('resolucionModal');
    this.dataResolution = items;
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }


  getResolution() {
    this.dianService.getResolution(890106966).subscribe(resp => {
      this.arrayResolution = resp;
    })
  }





}
